module.exports = __webpack_public_path__ + "img/hero2.77f5dc0c.png";